import { Flex, Skeleton } from '@eqi-investimentos/react';

export const InvestViewSkeleton = () => (
  <Flex>
    <Flex flexDir="column" position="relative">
      <Flex flexDir="column" w="full" px="3.25rem">
        <Skeleton w="12.5rem" h="0.875rem" />
        <Flex w="12.5rem" h="2.5rem" mt="0.625rem">
          <Skeleton w="12.5rem" h="2.5rem" />
        </Flex>

        <Flex
          w="full"
          display="inline-flex"
          justifyContent="flex-start"
          gap="2.5rem"
          mt="1.875rem"
        >
          {Array.from({ length: 2 }).map(() => (
            <Flex key={crypto.randomUUID()}>
              <Flex w="full" display="inline-flex" justifyContent="flex-start">
                <Skeleton w="1.25rem" h="1.25rem" mr="0.5rem" />
                <Skeleton w="3.75rem" h="1.25rem" />
              </Flex>
              <Skeleton w="6.875rem" h="1.25rem" />
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex flexDir="column" w="full" mt="1.875rem">
        <Skeleton w="100%" h="21.875rem" />
      </Flex>

      <Flex flexDir="column" w="full" px="3.25rem">
        <Flex w="full" mb="1rem" mt="3.125rem">
          {Array.from({ length: 3 }).map(() => (
            <Flex
              key={crypto.randomUUID()}
              w="full"
              h="2.188rem"
              flexDir="row"
              justifyContent="space-between"
              alignItems="center"
              py="0.625rem"
              mb="1rem"
            >
              <Skeleton w="1.875rem" h="1.875rem" />
              <Flex as="p" w="full" textAlign="left" ml="1rem">
                <Skeleton w="12.5rem" h="1.875rem" />
              </Flex>
              <Skeleton w="0.938rem" h="0.938rem" />
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex flexDir="column" w="full" mt="1.563rem" px="3.25rem">
        <Skeleton w="100%" h="7.5rem" />
      </Flex>

      <Flex w="full" h="12.5rem" />
    </Flex>
  </Flex>
);
